import colors from "@/styles/colors"

export const chartColors = {
	enqueued: colors.unrelated.CC456D,
	onGoing: colors.unrelated.EBAF78,
	finished: colors.unrelated["50C7AC"]
}
